import React, { useEffect, useState } from 'react';
import EnhancedAdSenseUnit from '../../../components/EnhancedAdSenseUnit';
import { getAdVariant, getAdPlacementConfig } from '../../../utils/adTesting';

const AdPlacement = ({ position }) => {
  const [variant, setVariant] = useState('control');
  const [adConfig, setAdConfig] = useState(null);

  useEffect(() => {
    // Get user's A/B test variant
    const userVariant = getAdVariant();
    setVariant(userVariant);

    // Get ad placement configuration for this page and variant
    const configs = getAdPlacementConfig(userVariant, 'debt-freedom-calculator');
    const config = configs?.find(c => c?.position === position);
    setAdConfig(config);
  }, [position]);

  // Don't render if this position is not in the variant's config
  if (!adConfig) {
    return null;
  }

  return (
    <div className="w-full max-w-2xl mx-auto">
      <EnhancedAdSenseUnit
        slot={adConfig?.slot}
        format={adConfig?.format}
        responsive={true}
        position={position}
        variant={variant}
        className="transition-opacity duration-300"
      />
    </div>
  );
};

export default AdPlacement;